module.exports = __webpack_public_path__ + "img/go_back.6590a453.svg";